module.exports = __webpack_public_path__ + "img/real-price-hashtag.7217bb0a.svg";